import React from "react"

import { randomNumber } from "utils"

const Waitinggif = ({className = ""}) => {
    const num = randomNumber(1, 6)

    return (
        <div className={ className }>
            <img alt="gif" src={ `/assets/gif_tiger_${num}.gif` } />
        </div>
    )
}

export default Waitinggif
